import { ENV } from "@/enum/system";

import { BaseSDK, SDKConfig } from "./base";
import { SDKName } from "./types";

interface TiktokConfig extends SDKConfig {
  pixelId?: string;
  accessToken?: string;
}

declare global {
  interface Window {
    ttq?: {
      (
        command: string,
        pixelId: string,
        eventName?: string,
        parameters?: Record<string, unknown>,
      ): void;
      load: (pixelId: string) => void;
      page: () => void;
      instance: (pixelId: string) => {
        track: (
          eventName: string,
          parameters?: Record<string, unknown>,
        ) => void;
      };
    };
  }
}

export class TiktokSDK extends BaseSDK {
  private pixelId: string;
  constructor(config: TiktokConfig) {
    super(SDKName.TiktokSDK, config);
    this.pixelId = config.pixelId || "";
  }

  async initialize(): Promise<void> {
    if (!window.ttq) {
      const script = document.createElement("script");
      script.textContent = `!function (w, d, t) {
        w.TiktokAnalyticsObject=t;
        var ttq=w[t]=w[t]||[];
        ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"];
        ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};
        for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);
        ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e};
        ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};n=document.createElement("script");n.type="text/javascript",n.async=!0,n.src=i+"?sdkid="+e+"&lib="+t;e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)};
        
        ttq.load('${this.pixelId}');
        ttq.page();
      }(window, document, 'ttq');`;
      document.head.appendChild(script);
    } else if (this.pixelId) {
      window.ttq.load(this.pixelId);
      window.ttq.page();
    }
  }

  // 跟踪自定义事件
  trackEvent(eventName: string, parameters?: Record<string, unknown>): void {
    if (window.ttq && typeof window.ttq.instance === "function") {
      window.ttq.instance(this.pixelId).track(eventName, parameters || {});
    } else {
      console.warn("[TiktokPixel] ttq not ready");
    }
  }

  reportEvent(event: string, data: Record<string, unknown>) {
    let result = false;
    if (window.ttq && typeof window.ttq.instance === "function") {
      try {
        window.ttq
          .instance(this.pixelId)
          .track(this.getTiktokEventName(event), data || {});
        result = true;
      } catch (error) {
        console.error("TiktokSDK reportEvent error", error);
      } finally {
        result = true;
      }
    } else {
      console.warn("[TiktokPixel] ttq not ready");
    }
    return result;
  }
  //根据ga事件名获取tiktok事件名
  getTiktokEventName(tkEvent: string) {
    let tiktokEvent = "";

    if (!tiktokEvent) {
      switch (tkEvent) {
        case "register":
          tiktokEvent = "CompleteRegistration";
          break;
        case "purchase":
          tiktokEvent = "Purchase";
          break;
        case "recharge":
          tiktokEvent = "AddToCart";
          break;
      }
    }
    if (!tiktokEvent) {
      tiktokEvent = tkEvent;
    }
    return tiktokEvent;
  }
}
